import { Link } from 'react-router-dom';
import { Button, Modal } from 'antd';

import { useState } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { commas } from '../../methods/utils/general-utils';
import { useAppDispatch } from '../../methods/redux/hooks';
import { registerInvestment } from '../../methods/redux/reducers/investment';

const InvestmentProfileStyle = styled.div`
	padding: 15px;
	background-color: #f8f8f8;
	margin-bottom: 10px;

	& .title {
		font-size: 18px;
		text-transform: capitalize;
	}

	& .details {
		display: flex;
		flex-wrap: wrap;
		justify-items: space-between;
		align-items: flex-end;
		border-top: 1px dashed #ccc;
		margin-top: 10px;

		& > * {
			min-width: 100px;
			margin-right: 15px;
			padding: 5px 0;
			font-size: 13px;

			& .label {
				color: #bbb;
				font-size: 12px;
			}
		}
	}
`;

interface UserProfile {
	_id: string;
	username: string;
}

interface InvestmentProfile {
	_id: string;
	title: string;
	userId: UserProfile | null;
	investmentForm: string;
	investmentStatus: string;
	riseInvestmentId: string;
	createdAt: string;
	status: string;
	totalDeposit: number;
	totalProfit: number;
	totalWithdrawn: number;
	updatedAt: string;
	currencyId: any;
	name: string;
}

interface IInvestment {
	investmentProfile: InvestmentProfile;
}

const InvestmentList = ({ investmentProfile }: IInvestment) => {
	const dispatch = useAppDispatch();
	// Helper function to get color based on investment status
	const getStatusColor = (status?: string) => {
		switch (status) {
			case 'running':
				return 'green';
			case 'terminated':
				return 'red';
			default:
				return 'inherit';
		}
	};
	const [state, setState] = useState({
		investmentId: investmentProfile?._id,
	});

	const [visible, setVisible] = useState(false);

	const submit = async () => {
		const response = await dispatch(registerInvestment({ ...state }));
		if (response) {
			setState({
				investmentId: '',
			});
		}

		// window.location.reload();
		setVisible(false);
	};

	return (
		<InvestmentProfileStyle>
			<div
				style={{
					display: 'flex',
				}}
			>
				<Link
					to={`/core-modules/investment/users/single?investmentId=${
						investmentProfile?._id || ''
					}`}
					className="title"
				>
					{investmentProfile?.title || 'Untitled'}
				</Link>

				{!investmentProfile?.riseInvestmentId ? (
					<Button
						style={{ marginLeft: 'auto' }}
						type="primary"
						onClick={() => setVisible(true)}
					>
						Retry Investment
					</Button>
				) : null}
			</div>
			<div className="details">
				<div>
					<Link to={`/user-profile/${investmentProfile?.userId?._id}`}>
						@{investmentProfile?.userId?.username || 'Unknown'}
					</Link>
					<p className="label">UserName</p>
				</div>

				<div>
					<p>{investmentProfile?.investmentForm || 'N/A'}</p>
					<p className="label">Investment Form</p>
				</div>

				<div>
					<p>{investmentProfile?.riseInvestmentId || 'N/A'}</p>
					<p className="label">Rise Investment ID</p>
				</div>

				<div>
					<p
						style={{
							color: getStatusColor(investmentProfile?.investmentStatus),
						}}
					>
						{investmentProfile?.investmentStatus || 'N/A'}
					</p>
					<p className="label">Investment Status</p>
				</div>

				<div>
					<p>{investmentProfile?.status || 'N/A'}</p>
					<p className="label">Status</p>
				</div>

				<div>
					<p>
						{commas(investmentProfile?.totalDeposit || 0)}{' '}
						{investmentProfile?.currencyId?.symbol}
					</p>
					<p className="label">Total Deposit</p>
				</div>

				<div>
					<p>
						{commas(investmentProfile?.totalProfit || 0)}{' '}
						{investmentProfile?.currencyId?.symbol}
					</p>
					<p className="label">Total Profit</p>
				</div>

				<div>
					<p>
						{commas(investmentProfile?.totalWithdrawn || 0)}{' '}
						{investmentProfile?.currencyId?.symbol}
					</p>
					<p className="label">Total Withdrawn</p>
				</div>

				<div>
					<p>
						{investmentProfile?.createdAt
							? moment(investmentProfile.createdAt).format(
									'MMM D, YY / hh:mm:ss a'
							  )
							: 'N/A'}
					</p>
					<p className="label">Created Date</p>
				</div>

				<div>
					<p>
						{investmentProfile?.updatedAt
							? moment(investmentProfile.updatedAt).format(
									'MMM D, YY / hh:mm:ss a'
							  )
							: 'N/A'}
					</p>
					<p className="label">Updated At</p>
				</div>
			</div>
			{investmentProfile?._id && (
				<Modal
					okText="Confirm"
					title="Retry Investment"
					onOk={submit}
					visible={visible}
					onCancel={() => setVisible(false)}
				>
					{/* <p>Bvn Number</p>
				<Input
					value={state.bvn}
					onChange={(e) => setState({ ...state, bvn: e.target.value })}
				/> */}
					<p>Are you sure you want to retry this investment?</p>
				</Modal>
			)}
		</InvestmentProfileStyle>
	);
};
export default InvestmentList;
